module.exports = require("./de-AT");